import React, { useState } from 'react';
import { Thead } from './Thead';
import { ActionCell } from './ActionCell';
import { Actions } from './Actions';
import { Button } from './Button';

interface TableData {
  id: number;
  name: string;
  email: string;
  role: string;
}

interface TableHeader {
  id: string;
  label: string;
}

export const Table = () => {

  const headers: TableHeader[] = [
    { id: 'id', label: 'ID' },
    { id: 'name', label: 'Имя' },
    { id: 'email', label: 'Email' },
    { id: 'role', label: 'Роль' },
    { id: 'actions', label: 'Действия' }
  ];

  const [data, setData] = useState<TableData[]>([
    { id: 1, name: 'John Doe', email: 'john@example.com', role: 'Admin' },
    { id: 2, name: 'Jane Smith', email: 'jane@example.com', role: 'User' },
    { id: 3, name: 'Bob Johnson', email: 'bob@example.com', role: 'Editor' },
    { id: 4, name: 'Alice Brown', email: 'alice@example.com', role: 'User' },
    { id: 5, name: 'Charlie Wilson', email: 'charlie@example.com', role: 'Admin' },
    { id: 6, name: 'Diana Ross', email: 'diana@example.com', role: 'Editor' },
    { id: 7, name: 'Edward Lee', email: 'edward@example.com', role: 'User' },
  ]);

  const [editingId, setEditingId] = useState<number | null>(null);
  const [editName, setEditName] = useState('');

  const handleEdit = (id: number, currentName: string) => {
    setEditingId(id);
    setEditName(currentName);
  };

  const handleSave = () => {
    if (editingId) {
      setData(data.map(item => 
        item.id === editingId ? { ...item, name: editName } : item
      ));
      setEditingId(null);
      setEditName('');
    }
  };

  const handleCancel = () => {
    setEditingId(null);
    setEditName('');
  };

  const handleDelete = async (id: number) => {
    setData(data.filter(row => row.id !== id));
  };

  return (
    <div>
      <table className="min-w-full border-collapse border border-gray-300">
        <Thead headers={headers} />
        <tbody>
          {data.map((row) => (
            <tr key={row.id} className="hover:bg-gray-50">
              <td className="border border-gray-300 px-4 py-2">{row.id}</td>
              <td className="border border-gray-300 px-4 py-2">
                {editingId === row.id ? (
                  <input
                    type="text"
                    value={editName}
                    onChange={(e) => setEditName(e.target.value)}
                    className="border border-gray-300 px-2 py-1 rounded"
                  />
                ) : (
                  row.name
                )}
              </td>
              <td className="border border-gray-300 px-4 py-2">{row.email}</td>
              <td className="border border-gray-300 px-4 py-2">{row.role}</td>
              {/* Паттерн Slot обеспечивает гибкость и переиспользуемость, минус это лесенкообразный вывод */}
              <ActionCell
                actions={<Actions 
                  row={row}
                  editingId={editingId}
                  saveButton={
                    <Button 
                      onClick={handleSave}
                      className="bg-green-500 text-white px-3 py-1 rounded mr-2 hover:bg-green-600"
                    >
                      Сохранить
                    </Button>
                  }
                  cancelButton={
                    <Button 
                      onClick={handleCancel}
                      className="bg-gray-500 text-white px-3 py-1 rounded hover:bg-gray-600"
                    >
                      Отмена
                    </Button>
                  }
                  editButton={
                    <Button 
                      onClick={() => handleEdit(row.id, row.name)}
                      className="bg-blue-500 text-white px-3 py-1 rounded mr-2 hover:bg-blue-600"
                    >
                      Редактировать
                    </Button>
                  }
                  deleteButton={
                    <Button
                      onClick={() => handleDelete(row.id)}
                      className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                    >
                      Удалить
                    </Button>
                  }
                />}
              />
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
